module.exports = __webpack_public_path__ + "media/images/realizacje/real12-ca1685a20e5c31cf7113437a0de0d0b0.png";